import React, { memo } from 'react';
import { PasswordInput } from '@adc/parallax-component-library';
const InputPassword = memo(({ isInvalid = false, label = '', errorMessage, placeholder = '', mt, mb, autoComplete = 'current-password', onChangeText, testID, value, ...rest }) => {
    return (React.createElement(PasswordInput, { label: label, valid: isInvalid ? 'no' : 'yes', ariaLabelExtractor: () => '', hideButtonAriaLabelExtractor: () => '', autoComplete: autoComplete, marginTop: mt, marginBottom: mb, placeholder: placeholder, onChangeText: onChangeText, supportingText: isInvalid ? errorMessage : undefined, testID: testID, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        value: value, ...rest }));
});
InputPassword.displayName = 'InputPassword';
export { InputPassword };
